import { UntypedFormBuilder } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { PagingSearchCriteria } from "src/app/shared/model/PagingSearchCriteria";

export interface SearchPortalUsersCriteria extends PagingSearchCriteria {
    nameOrSurname?: string;
    username?: string;
    portalUserId: string;
    workshopId?: number;
    onlyActive?: boolean;
    phoneNumber?: string;
    email?: string;
    text?: string;
    includePortalUserLinks?: boolean;
}

export class SearchPortalUsersCriteriaFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, searchCriteria: SearchPortalUsersCriteria) {
  
      return fb.group(
        {
          text: [searchCriteria.text],
          nameOrSurname: [searchCriteria.nameOrSurname],
          phoneNumber: [searchCriteria.phoneNumber],
          workshopId: [searchCriteria.workshopId],
          email: [searchCriteria.email],
          username: [searchCriteria.username],
          onlyActive: [searchCriteria.onlyActive],

        }
      );
    }

    static initSearchPortalUsersCriteria(onlyActive: boolean) : SearchPortalUsersCriteria {
      return {
        portalUserId: null,
        username: '',
        phoneNumber: '',
        nameOrSurname: '',
        onlyActive: onlyActive,
        pageNumber: 1,
        rowsPerPage: 10,
        includePortalUserLinks: true,
        sortDirection: '',
        sortColumn: ''

      };
    }
  }